import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { LayoutDashboard, Package, Megaphone, FileText, ClipboardList, User, LogOut, ExternalLink, History } from 'lucide-react';

const NAV = [
  { section: 'Main', items: [
    { id: 'dashboard', label: 'Dashboard', icon: LayoutDashboard },
  ]},
  { section: 'Order & Supplies', items: [
    { id: 'supplies', label: 'Reorder Supplies', icon: Package },
    { id: 'orders', label: 'Order History', icon: History },
    { id: 'custom-order', label: 'Custom Orders', icon: ClipboardList },
  ]},
  { section: 'Resources', items: [
    { id: 'marketing', label: 'Marketing Materials', icon: Megaphone },
    { id: 'documents', label: 'Documents & Forms', icon: FileText },
  ]},
  { section: 'Account', items: [
    { id: 'account', label: 'Account Settings', icon: User },
  ]},
];

export default function Layout({ children, currentPage, setCurrentPage }) {
  const { user, profile, signOut } = useAuth();
  const [logoErr, setLogoErr] = useState(false);
  const initials = (profile?.full_name || user?.email || 'P').split(' ').map(n => n[0]).slice(0, 2).join('').toUpperCase();
  const displayName = profile?.full_name || user?.email?.split('@')[0] || 'Provider';
  const tier = profile?.subscription_tier || 'Preferred Provider';

  return (
    <div className="portal-layout">
      <aside className="sidebar">
        <div className="sidebar-header">
          {!logoErr
            ? <img src="https://neurogenx.com/wp-content/uploads/2022/01/Neurogenx-Logo.png" alt="Neurogenx" className="sidebar-logo" onError={() => setLogoErr(true)} />
            : <div className="sidebar-logo-fallback">Neurogenx</div>}
          <div className="sidebar-user">
            <div className="user-avatar">{initials}</div>
            <div className="user-info">
              <div className="user-name">{displayName}</div>
              <div className="user-tier"><span className="tier-badge"></span>{tier}</div>
            </div>
          </div>
        </div>
        <nav className="sidebar-nav">
          {NAV.map(s => (
            <div key={s.section}>
              <div className="nav-section-label">{s.section}</div>
              {s.items.map(item => { const Icon = item.icon; return (
                <button key={item.id} className={`nav-item ${currentPage === item.id ? 'active' : ''}`} onClick={() => setCurrentPage(item.id)}>
                  <Icon size={16} />{item.label}
                </button>
              ); })}
            </div>
          ))}
        </nav>
        <div className="sidebar-footer">
          <a href="https://neurogenx.com" target="_blank" rel="noopener noreferrer" className="sidebar-footer-link"><ExternalLink size={14} />Visit Neurogenx.com</a>
          <button className="signout-btn" onClick={signOut}><LogOut size={14} />Sign Out</button>
        </div>
      </aside>
      <main className="main-content">{children}</main>
    </div>
  );
}
